import { z } from 'zod'

const inputCommentLinkSchema = z.object({
  link: z
    .string()
    .url({
      message: 'O link deve ser uma URL válida',
    })
    .min(1, {
      message: 'O link é obrigatório',
    }),
})

type InputCommentLinkFormData = z.infer<typeof inputCommentLinkSchema>

export { inputCommentLinkSchema, type InputCommentLinkFormData }
